import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderModule } from '@app/shared/loader/loader.module';
import { FormsModule } from '@app/shared/forms/forms.module';
import { ByocCourseComponent } from './course.component';
import { ByocCourseStepGeneralComponent } from './step/general/general.component';
import { ByocCourseStepMissionComponent } from './step/mission/mission.component';
import { ByocCourseStepMissionListComponent } from './step/mission/list/list.component';
import { ByocCourseStepPositionComponent } from './step/position/position.component';
import { ByocCourseStepPositionListComponent } from './step/position/list/list.component';
import { DirectiveMissionModule } from '../mission/directive/directive-mission.module';
import { ByocCourseStepWarningComponent } from './step/warning-empty/warning-empty.component';
import { SharedModule } from '@app/shared';
import { EnterKeyUpModule } from '@app/shared/accesibility/keyboard-shortcuts';
import { AriaLabelModule } from '@app/shared/accesibility/aria-label/aria-label.module';
import { AriaDisabledModule } from '@app/shared/accesibility/aria-disabled/aria-disabled.module';
import { FormsDropdownACModule } from '@app/shared/forms/dropdown-ac/dropdown-ac.module';
import { DataTestModule } from '@app/shared/directive/data-test';
import { PerfectScrollbarModule } from '@app/shared/perfect-scrollbar/perfect-scrollbar.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ReactiveFormsModule,
        InlineSVGModule,
        NgbTooltipModule,
        DirectiveMissionModule,
        LoaderModule,
        FormsModule,
        FormsDropdownACModule,
        SharedModule,
        EnterKeyUpModule,
        AriaLabelModule,
        AriaDisabledModule,
        DataTestModule,
        PerfectScrollbarModule,
    ],
    declarations: [
        ByocCourseComponent,
        ByocCourseStepGeneralComponent,
        ByocCourseStepMissionComponent,
        ByocCourseStepMissionListComponent,
        ByocCourseStepPositionComponent,
        ByocCourseStepPositionListComponent,
        ByocCourseStepWarningComponent,
    ],
})
export class ByocPopupCourseModule {}
